export default __webpack_public_path__ + "static/media/BG-image.6f2f0b7e.jpg";